/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGenAiButton = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 5h7v2H4v10h16v-5h2v7H2z" />
        <path d="m17 2.176 2.306 3.518L22.824 8l-3.518 2.306L17 13.824l-2.306-3.518L11.176 8l3.518-2.306zm0 3.648-.862 1.314L14.824 8l1.314.862.862 1.314.862-1.314L19.176 8l-1.314-.862zM12 .176l1.118 1.706L14.824 3l-1.706 1.118L12 5.824l-1.118-1.706L9.176 3l1.706-1.118z" />
      </g>
    </g>
  </Icon>
);
export { SvgGenAiButton as GenAiButton };
